import React from "react";
import { Popup } from "@progress/kendo-react-popup";
import { button } from "../../../config";

/**
 * More menu popup component for queue actions
 * @author Bhavana
 */
const MoreMenuPopup = ({ anchor, show, onClose, onDeleteWorkspace, icon }) => {
  if (!show) return null;

  return (
    <Popup anchor={anchor} show={show} animate={true} popupClass='more-menu-popup more-menu-popup-queue'>
      <div className='more-menu-container'>
        <div className='more-menu-item' onClick={onDeleteWorkspace}>
          <span className='mr-2 grey'>{icon?.TRASH}</span>
          {button.DELETE_QUEUE}
        </div>
      </div>
    </Popup>
  );
};

export default MoreMenuPopup;
